import {
  type RecommendedContents,
  type AvailableContentTypes,
} from 'hb-react/shared/components/ContentRecommendation/types';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

interface GetRecommendedContentsParams {
  contentId: number;
  contentType: AvailableContentTypes;
  contentTypes: Array<AvailableContentTypes>;
  group_id?: number;
  limit: number;
  scoreThreshold: number;
}

export const getRecommendedContents = ({
  params,
  signal,
}: {
  params: GetRecommendedContentsParams;
  signal?: AbortSignal;
}) => {
  const path = Routes.private_frontoffice_ai_recommendations_path();

  return axios.get<{
    data: Array<RecommendedContents[AvailableContentTypes]>;
    total: number;
  }>(path, {
    signal,
    params,
  });
};
